import { CustomTabPanel } from "@/erp/sale/component";
import { a11yProps, useTabsFormOnly } from "@/shared";
import { FormTabsOnly, SingleBoxTableTabsOnly, SingleTableBoxScene } from "@/shared/components/ui";
import { Tab } from "@mui/material";
import TableReporteContratosPendientes from "../componente/TableReporteContratosPendientes";
export default function ReporteContratosPendientesPage() {

  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 0
  });

  return (
    <SingleTableBoxScene
      title="Reporte de Contratos Pendientes"
    >
      <SingleBoxTableTabsOnly>
        <FormTabsOnly
          sxTabs={{
            mb: 0,
            pl: 0,
            ml: 0,
          }}
          onChange={handleMethodChange}
          value={valueTab}
        >
          {/* <Tab label={'Resumen'} {...a11yProps(0)} /> */}
          <Tab label={'Reporte'} {...a11yProps(0)} />
          {/* <Tab label={'Gráficos'} {...a11yProps(2)} /> */}
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* <CustomTabPanel index={valueTab} value={0}>
        <ResumenReporteVenta />
      </CustomTabPanel> */}

      <CustomTabPanel index={valueTab} value={0}>
        <TableReporteContratosPendientes />
      </CustomTabPanel>

    </SingleTableBoxScene>
  )

}